import { Component, Input, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ICONS } from '../../_helpers/icons.constants';

export interface DropdownItem {
  label: string;
  route: any;
  icon?: string;
  isDivider?: boolean;
}

@Component({
  selector: 'app-common-dropdown',
  templateUrl: './common-dropdown.component.html',
  standalone: true,
  imports: [CommonModule]
})
export class CommonDropdownComponent {
  public ICONS = ICONS;
    handleDropdownClick(event: Event): void {
      if (this.dropdownItems && this.dropdownItems.length > 0) {
        this.toggleDropdown();
        event.preventDefault();
      } else {
        this.onItemClick({label: this.dropdownLabel, route: this.dropdownRoute}, event);
      }
    }
  @Input() dropdownLabel: string = '';
  @Input() dropdownItems: DropdownItem[] = [];
  @Input() dropdownRoute: any;
  @Input() activeClass: string = '';
  
  @Output() itemSelected = new EventEmitter<DropdownItem>();

  isOpen = false;

  constructor(private elementRef: ElementRef) {}

  toggleDropdown(): void {
    this.isOpen = !this.isOpen;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }

  onItemClick(item: DropdownItem, event: Event): void {
    event.preventDefault();
    if (!item.isDivider) {
      this.itemSelected.emit(item);
    }
    this.isOpen = false;
  }
  onDropdownClick(item: DropdownItem, event: Event): void {
    event.preventDefault();
    if (!item.isDivider) {
      this.itemSelected.emit(item);
    }
    this.isOpen = false;
  }
}
